/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientEmployeeLastUsedTimeStatQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  employeeId: Types.Scalars['UUID']['input'];
}>;


export type ClientEmployeeLastUsedTimeStatQuery = { __typename: 'Query', employeeSessions?: { __typename: 'ClientEmployeeSessionTypeConnection', aggregate?: { __typename: 'ClientEmployeeSessionAggregateType', max?: { __typename: 'ClientEmployeeSessionAggregateMaxFieldType', updatedAt?: string | null } | null } | null } | null };



export const ClientEmployeeLastUsedTimeStatDocument = `
    query ClientEmployeeLastUsedTimeStat($clientId: UUID!, $employeeId: UUID!) {
  employeeSessions(clientId: $clientId, employeeId: $employeeId) {
    aggregate {
      max {
        updatedAt
      }
    }
  }
}
    `;

export const useClientEmployeeLastUsedTimeStatQuery = <
      TData = ClientEmployeeLastUsedTimeStatQuery,
      TError = unknown
    >(
      variables: ClientEmployeeLastUsedTimeStatQueryVariables,
      options?: Omit<UseQueryOptions<ClientEmployeeLastUsedTimeStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientEmployeeLastUsedTimeStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientEmployeeLastUsedTimeStatQuery, TError, TData>(
      {
    queryKey: ['ClientEmployeeLastUsedTimeStat', variables],
    queryFn: fetcher<ClientEmployeeLastUsedTimeStatQuery, ClientEmployeeLastUsedTimeStatQueryVariables>(ClientEmployeeLastUsedTimeStatDocument, variables),
    ...options
  }
    )};

useClientEmployeeLastUsedTimeStatQuery.getKey = (variables: ClientEmployeeLastUsedTimeStatQueryVariables) => ['ClientEmployeeLastUsedTimeStat', variables];

export const useInfiniteClientEmployeeLastUsedTimeStatQuery = <
      TData = InfiniteData<ClientEmployeeLastUsedTimeStatQuery>,
      TError = unknown
    >(
      variables: ClientEmployeeLastUsedTimeStatQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientEmployeeLastUsedTimeStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientEmployeeLastUsedTimeStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientEmployeeLastUsedTimeStatQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientEmployeeLastUsedTimeStat.infinite', variables],
      queryFn: (metaData) => fetcher<ClientEmployeeLastUsedTimeStatQuery, ClientEmployeeLastUsedTimeStatQueryVariables>(ClientEmployeeLastUsedTimeStatDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientEmployeeLastUsedTimeStatQuery.getKey = (variables: ClientEmployeeLastUsedTimeStatQueryVariables) => ['ClientEmployeeLastUsedTimeStat.infinite', variables];


useClientEmployeeLastUsedTimeStatQuery.fetcher = (variables: ClientEmployeeLastUsedTimeStatQueryVariables) => fetcher<ClientEmployeeLastUsedTimeStatQuery, ClientEmployeeLastUsedTimeStatQueryVariables>(ClientEmployeeLastUsedTimeStatDocument, variables);
